import RelatedItems from './relatedItems.js';
export default RelatedItems;